<template lang="pug">
  .chart-component
    .chart-wrapper
      .chart
        apexchart(
          ref="apexChartRef"
          height="315"
          :options="chartOptions"
          :series="chartSeries"
          :key="chartComponentKey"
          @mousedown="disableTooltip"
          @mouseup="enableTooltip"
        )
      br
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "PowerChart",

  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    // e.g. [{ key: 'ext_pre_sleep', label: 'Ext Pre-Sleep' }, { key: 'bat_pre_sleep', label: 'Bat Pre-Sleep' }, ...]
    pairs: {
      type: Array,
      required: true,
    },
  },

  components: {
    apexchart: VueApexCharts,
  },

  data() {
    return {
      chartSeries: this.pairs.map((pair) => ({ name: pair.label, data: [] })),
      chartComponentKey: 0,
    };
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          type: "line",
          height: 400,
          zoom: {
            enabled: true,
            zoomOnMouseWheel: false,
            zoomOnTouch: false,
            enabledOnChart: true,
            type: "x",
            autoScaleYaxis: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          markers: {  
            size: 4,
            hover: { size: 6 }, 
          },
          toolbar: {
            tools: { zoom: true, zoomin: false, zoomout: false, pan: false, reset: true },
          },
          events: {
            selection: (chartContext, { xaxis }) => {
              this.$emit("onZoom", [new Date(xaxis.min).toISOString(), new Date(xaxis.max).toISOString()]);
            },
          },
        },
        colors: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f"],
        dataLabels: { enabled: false },
        plotOptions: { bar: { horizontal: false, columnWidth: "70%", endingShape: "rounded" } },
        xaxis: {
          type: "datetime",
          labels: {
            formatter: (val) => new Date(val).toLocaleTimeString(undefined, {
              day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true,
            }),
          },
        },
        yaxis: { title: { text: "mV" } },
        fill: { opacity: 1 },
        tooltip: {
          shared: true,
          intersect: false,
          y: { formatter: (val) => `${val} mV` },
        },
        legend: { position: "bottom" },
      };
    },
  },

  watch: {
    chartData() {
      this.mapInfosForChart();
    },
  },

  methods: {
    disableTooltip() {
      this.$refs.apexChartRef?.chart?.updateOptions({ tooltip: { enabled: false } }, false, false);
    },
    enableTooltip() {
      this.$refs.apexChartRef?.chart?.updateOptions({ tooltip: { enabled: true } }, false, false);
    },

    cleanValue(value) {
      if (value === null || value === undefined) return null;
      const num = Number(value);
      if (Number.isNaN(num)) return null;
      return num === 0 ? 0.1 : num;
    },

    mapInfosForChart() {
      this.chartSeries = this.pairs.map((pair) => ({ name: pair.label, data: [] }));

      this.chartData.forEach((info) => {
        const timestamp = new Date(info.created_at).getTime();
        this.pairs.forEach((pair, i) => {
          const value = info[pair.key];
          this.chartSeries[i].data.push({ x: timestamp, y: this.cleanValue(value) });
        });
      });

      this.chartComponentKey += 1;
    },
  },
};
</script>
